import { ReactNode } from "react";
import { Badge, BadgeProps, Flex } from "@mantine/core";

export interface CampaignBadgeProps extends BadgeProps {
    icon?: ReactNode;
    color?: string;
    textColor?: string;
    children: ReactNode;
}

export const CampaignBadge = ({ textColor, icon, color, children, ...props }: CampaignBadgeProps) => {
    return (
        <Badge
            color={color}
            sx={{
                backgroundColor: textColor ? color : undefined,
                color: textColor,
                paddingBlock: 4,
                paddingLeft: icon ? 6 : 8,
                paddingRight: 8,
                height: 24,
                fontWeight: 600,
                textTransform: "unset",
                fontSize: 14,
                "& .mantine-Badge-inner": {
                    display: "flex",
                    alignItems: "center",
                },
            }}
            {...props}
        >
            {icon && <Flex mr={6}>{icon}</Flex>}
            {children}
        </Badge>
    );
};
